<div>
  {{ 'chat.feedback.prompt' | transloco }}
</div>

<div class="mt-4 flex flex-row items-baseline gap-x-3">
  <!-- Like Button -->
  <p-button icon="pi pi-thumbs-up" [severity]="_message?.voting === 1 ? 'contrast' : 'secondary'" (onClick)="voteAnswer(1)" />

  <!-- Dislike Button -->
  <p-button icon="pi pi-thumbs-down" [severity]="_message?.voting === 0 ? 'contrast' : 'secondary'" (onClick)="voteAnswer(0)" />
</div>
